import "./styles.scss";

import { FaArrowLeft } from "react-icons/fa";
import { useNavigate } from "react-router-dom";

const ButtonBack = () => {
  const navigate = useNavigate();
  const handleGoBack = () => navigate(-1);

  return (
    <div className="wrapperButtonBack">
      <FaArrowLeft color="#000" size={20} onClick={handleGoBack} />
    </div>
  );
};

export default ButtonBack;
